module.exports = __webpack_public_path__ + "img/ia-banner.f452fc2d.jpg";